import useNamespacedLocalStorage from '../useNamespacedLocalStorage';

export default function useSelectedIsSuggested() {
  return useNamespacedLocalStorage('ostroSelectedIsSuggested', false);
}
